export const message = {
  saveFormRoleSuccessMessage: 'Roles successfully saved',
  publishFormRoleSuccessMessage: 'Roles successfully published'
}